import colors from 'assets/colors'

export const SP_STATUSES = [
  { value: 'pre-launch', label: 'Pré-lancement' },
  { value: 'opening', label: 'Ouverture' },
  { value: 'collecting', label: 'Collecte' },
  { value: 'closed', label: 'Clôturé' },
]

export const statusLabel = (status) => SP_STATUSES.find(({ value }) => value === status)?.label || status || '-'
export const statusColor = (status) => colors.badge.structured_product_status[status]

export const formatParisDate = (date) => date
  ? new Date(date).toLocaleDateString('fr-FR', { timeZone: 'Europe/Paris', day: '2-digit', month: 'short', year: 'numeric' })
  : '-'

export const formatAmount = (value) => value === undefined || value === null
  ? '-'
  : Number(value).toLocaleString('fr-FR', { maximumFractionDigits: 2 })

const isTermSheet = (doc) => /term.?sheet/i.test(doc?.title || '') || /\/term_sheets\//.test(doc?.url || '')

export const getTermSheetUrl = (product) => product.documents?.find(isTermSheet)?.url || null
